<template>
	<div class="data">
		<div class="data_main">
			<div class="dm_head">
				<div class="dmh_top">
					<div class="dmht_left">
						<span>设备最新数据</span>
					</div>
					<div class="dmht_right">
						<span>{{getTime(lastData.data_time)}}</span>
					</div>
				</div>
				<div class="dmh_bottom">
					<div class="dmhb_left">
						<span>{{property_name}}</span>
						<span>{{unit}}</span>
					</div>
					<div class="dmhb_right">
						<span>{{lastData.value}}</span>
					</div>
				</div>
			</div>

			<!-- 同设备多属性切换 -->
			<div class="prop_tabs" v-if="propertyTabs.length>1">
				<div v-for="p in propertyTabs" :key="p.id" class="prop_tab"
					:class="{active: String(p.id)==String(propertyId)}" @click="selectProperty(p)">
					{{p.name}}
				</div>
			</div>

			<div class="dm_data_more">
				<div class="ddm_title">
					<span>{{property_name}}走势图</span>
					<span>单位：{{unit}}</span>
				</div>
				<!-- 时间范围选择 -->
				<div class="range_row">
					<div v-for="r in rangeOptions" :key="r.days" class="range_chip"
						:class="{active: rangeDays==r.days}" @click="selectRange(r.days)">
						{{r.label}}
					</div>
				</div>
				<div class="tu_wrap">
					<div class="tu_data" id="dataindex"></div>
					<div class="tu_overlay" v-if="chartLoading">加载中…</div>
					<div class="tu_overlay" v-else-if="rawData.length==0">该时间段暂无历史数据</div>
				</div>
				<div class="chart_actions">
					<div class="action_btn" @click="exportCsv">导出 CSV</div>
					<span class="action_tip">双指/滑动可缩放，右上角可存图</span>
				</div>
			</div>

			<!-- 历史数据列表 -->
			<div class="dm_data_table">
				<div class="dmdw_title">
					<span>历史数据</span>
					<span class="table_tip" v-if="rawData.length>100">仅显示最近 100 条，完整数据请导出 CSV</span>
				</div>
				<div class="dt_row dt_head">
					<span>时间</span>
					<span>值（{{unit}}）</span>
				</div>
				<template v-if="tableList.length>0">
					<div class="dt_row" v-for="(row,i) in tableList" :key="i">
						<span>{{getTime(row.data_time)}}</span>
						<span class="dt_value">{{row.value}}</span>
					</div>
				</template>
				<div class="dt_empty" v-else>暂无数据</div>
			</div>

			<div class="dm_data_warning">
				<div class="dmdw_title">
					<span>设备报警范围</span>
					<div class="dmdw_btn" @click="toAddWarning">
						<i class="iconfont icon-xinzeng"></i>
						<span>新增</span>
					</div>
				</div>
				<div class="dmdw_list">
					<template v-for="item in warningList">
						<div class="dmdwl_div" :key="item.id">
							<div class="dmdwld_head">
								<div class="dd_left">
									<div class="ddl_tag" v-if="item.warning_type=='none'">
										<span>正常</span>
									</div>
									<div class="ddl_tag" style="background:#FFA14E" v-if="item.warning_type=='low'">
										<span>提醒</span>
									</div>
									<div class="ddl_tag" style="background:#FF5A4E" v-if="item.warning_type=='high'">
										<span>报警</span>
									</div>
									<div class="ddl_name">
										<span>{{deviceName}}</span>
									</div>
								</div>
								<div class="dd_right" >
									<i class="iconfont icon-bianji" @click="toEditWarning(item)"></i>
									<i class="iconfont icon-shanchu1" @click="deleteWarningDialog(item)"></i>
								</div>
							</div>
							<div class="dmdwld_content">
								<div class="dmdwldc_div">
									<span>{{property_name}}最小值</span>
									<span>{{item.min_value}}{{unit}}</span>
								</div>
								<div class="dmdwldc_div">
									<span>{{property_name}}最大值</span>
									<span>{{item.max_value}}{{unit}}</span>
								</div>

								<div class="dmdwldc_div">
									<span style="color:#999999">设置时间：{{item.create_time_str}}</span>
									<span></span>
								</div>
							</div>

						</div>
					</template>

				</div>
			</div>
		</div>


	</div>
</template>

<script>


import studio_login_api from '@/api/teaching_studio_no_login.js'
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import until from '@/api/until.js'
import * as echarts from 'echarts';
import download from 'downloadjs';
export default {
	name: 'Home',
	data() {
		return {
			lastData:{},
			unit:"",
			warningList:[],
			deviceName:'',
			property_name:'',
			property_key:"",
			device_id:"",
			propertyId:"",
			propertyTabs:[],       // 同设备属性切换
			rangeDays:3,           // 时间范围（天）
			rangeOptions:[
				{days:1,label:'今天'},
				{days:3,label:'近3天'},
				{days:7,label:'近7天'},
				{days:30,label:'近30天'},
			],
			chartLoading:false,
			rawData:[],            // 接口原始顺序（新→旧）
			tableList:[],
			warnLow:0,
			warnHigh:0,
			chartInstance:null,
		}
	},
	components: {

	},
	mounted() {
		document.title="更多数据"
		this.propertyId=this.$route.query.property_id
		this.unit=this.$route.query.unit
		this.property_key=this.$route.query.property_key
		this.deviceName=this.$route.query.deviceName
		this.device_id=this.$route.query.device_id||""
		if(this.$route.query.property_name){
			this.property_name=decodeURIComponent(this.$route.query.property_name)
		}
		this.loadPropertyTabs();
		this.loadAll();
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
		if(this.chartInstance){
			this.chartInstance.dispose();
			this.chartInstance=null;
		}
	},
	methods: {
		// 加载该设备的全部属性（多属性 Tab）
		async loadPropertyTabs(){
			if(!this.device_id) return;
			let app_id=this.$root.app_id;
			let device_id=this.device_id;
			let property_key="";
			let data=await studio_api.Teaching_studio_apiIot_device_propertyListGet({app_id,device_id,property_key});
			if(data.errcode==0 && data.other && data.other.list){
				this.propertyTabs=data.other.list.map(p=>({
					id:p.id,
					name:p.property_name,
					unit:p.property_unit,
					key:p.property_key,
				}));
			}
		},
		// 切换属性
		selectProperty(p){
			if(String(p.id)==String(this.propertyId)) return;
			this.propertyId=p.id;
			this.property_name=p.name;
			this.unit=p.unit;
			this.property_key=p.key;
			this.loadAll();
		},
		// 切换时间范围
		selectRange(days){
			if(this.rangeDays==days) return;
			this.rangeDays=days;
			this.getMoreData();
		},
		loadAll(){
			this.getNewData();
			this.getWarningList();
			this.getMoreData();
		},
		//获取当前属性的最新数据
		async getNewData(){
			let app_id=this.$root.app_id;
			let property_id=this.propertyId
			let data=await studio_api.Teaching_studio_apiIot_device_propertyDataLastGet({app_id,property_id});
			if(data.errcode==0){
				this.lastData=data.other;
			}
		},
		getTime(time){
			if(time){
				return until.formatDateHour(time*1000)
			}
			else{
				return ""
			}

		},
		//获取报警设置列表
		async getWarningList(){
			let app_id=this.$root.app_id;
			let property_id=this.propertyId
			let warning_type=""
			let data=await studio_api.Teaching_studio_apiIot_device_property_warningListGet({app_id,property_id,warning_type});
			if(data.errcode==0){
				this.warningList=data.other.list;
			}
		},
		deleteWarningDialog(item){
			this.$dialog.confirm({
				title: '标题',
				message: '是否确认删除',
			})
			.then(async () => {
				this.deleteWarning(item);

			})
			.catch(() => {
				// on cancel
			});
		},

		//删除报警设置
		async deleteWarning(item){
			let app_id=this.$root.app_id;
			let property_warning_id=item.id
			this.$toast.loading({
				message: "加载中...",
				forbidClick: false,
				duration: 0
			});
			let data=await studio_api.Teaching_studio_apiIot_device_property_warningDelDelete({app_id,property_warning_id});
			if(data.errcode==0){
				this.$toast("删除成功")
				this.getWarningList();
			}
		},

		async toAddWarning(){
			//获取更多数据

			let app_id=this.$root.app_id;
			let product_key=""
			let property_key=this.property_key
			let name=""
			this.$toast.loading({
				message: "加载中...",
				forbidClick: false,
				duration: 0
			});
			let data=await studio_api.Teaching_studio_apiWarning_range_quickListGet({app_id,product_key,property_key,name});
			if(data.errcode==0){
				this.$toast.clear()
				if(data.other.list.length>0){
					this.$router.push("/addshortselect?property_id="+this.propertyId+"&property_key="+this.property_key+"&property_name="+this.property_name);
				}
				else{
					this.$router.push("/addwarning?property_id="+this.propertyId+"&property_key="+this.property_key+"&property_name="+this.property_name+"&back_index=1");
				}

			}




		},
		toEditWarning(item){
			this.$router.push("/editwarning?property_id="+this.propertyId+"&property_key="+this.property_key+"&property_warning_id="+item.id+"&property_name="+this.property_name);
		},
		//获取历史数据
		async getMoreData(){
			let app_id=this.$root.app_id;
			let property_id=this.propertyId
			let end_time=Math.floor(Date.now()/1000);
			let begin_time=end_time-this.rangeDays*86400;
			this.chartLoading=true;
			this.rawData=[];
			this.tableList=[];
			try{
				let data=await studio_api.Teaching_studio_apiIot_device_propertyTimeDataGet({app_id,property_id,begin_time,end_time});
				if(data.errcode==0){
					if(!this.property_name){
						this.property_name=data.other.name
					}
					this.warnLow=Number(data.other.warning_low_min)||0;
					this.warnHigh=Number(data.other.warning_high_min)||0;
					this.rawData=Array.isArray(data.other.data)?data.other.data:[];
					// 接口返回新→旧；列表页保持新→旧，取前 100 条展示
					this.tableList=this.rawData.slice(0,100);
				}
			}finally{
				this.chartLoading=false;
			}
			this.$nextTick(()=>{
				this.drawChart();
			});
		},

		//绘制历史曲线
		drawChart(){
			if(this.chartInstance){
				this.chartInstance.dispose();
				this.chartInstance=null;
			}
			if(this.rawData.length==0) return;
			// 接口返回新→旧，翻转为旧→新再画（PC 端同样 reverse）
			let asc=this.rawData.slice().reverse();
			let xData=asc.map(res=>until.formatDateNoYear(res.data_time*1000));
			let yData=asc.map(res=>Number(res.value));
			let nums=yData.filter(v=>!isNaN(v));
			if(nums.length==0) return;
			let dataMax=Math.max(...nums);
			let dataMin=Math.min(...nums);
			let average=nums.reduce((a,b)=>a+b,0)/nums.length;
			// Y 轴自适应：包住数据与警戒线，上下各留 10%（与 PC 端一致）
			let yMax=(this.warnHigh===0||this.warnHigh<dataMax)?dataMax*1.1:this.warnHigh*1.1;
			let yMin=(this.warnLow===0||this.warnLow>dataMin)?dataMin*0.9:this.warnLow*0.9;
			if(yMax==yMin){ // 数据无波动时避免零高度
				yMax=yMax+1;
				yMin=yMin-1;
			}
			let markData=[
				this.warnLow!==0?{
					yAxis:this.warnLow,
					lineStyle:{color:'#00C853'},
					label:{color:'#00C853',fontSize:12,formatter:(e)=>`LUL ${e.value}`}
				}:null,
				{
					yAxis:Number(average.toFixed(2)),
					lineStyle:{color:'#ff0000'},
					label:{color:'#ff0000',fontSize:12,formatter:(e)=>`平均 ${e.value}`}
				},
				this.warnHigh!==0?{
					yAxis:this.warnHigh,
					lineStyle:{color:'#00C853'},
					label:{color:'#00C853',fontSize:12,formatter:(e)=>`LCL ${e.value}`}
				}:null,
			].filter(l=>l!==null);
			let chartDom=document.getElementById('dataindex');
			this.chartInstance=echarts.init(chartDom);
			this.chartInstance.setOption({
				tooltip:{
					trigger:'axis',
				},
				toolbox:{
					right:10,
					feature:{
						saveAsImage:{title:'存图'}
					}
				},
				grid:{
					top:30,
					left:50,
					bottom:60,
					right:15,
				},
				dataZoom:[
					{type:'inside',start:0,end:100},
					{type:'slider',start:0,end:100,height:18,bottom:8},
				],
				xAxis:{
					type:'category',
					data:xData,
					axisTick:{show:false},
					axisLine:{show:false},
					splitLine:{
						show:true,
						lineStyle:{type:'dashed'},
					},
				},
				yAxis:{
					type:'value',
					min:Number(yMin.toFixed(2)),
					max:Number(yMax.toFixed(2)),
					name:'单位('+this.unit+')',
					axisTick:{show:false},
					axisLine:{show:false},
					splitLine:{
						show:true,
						lineStyle:{type:'dashed'},
					},
				},
				series:[
					{
						name:this.property_name,
						data:yData,
						type:'line',
						smooth:true,
						markLine:{
							data:markData,
							silent:false,
							symbol:false,
							lineStyle:{color:'red',type:'dashed',width:1},
						},
					}
				]
			});
		},
		// 导出 CSV（完整时间段数据，新→旧）
		exportCsv(){
			if(this.rawData.length==0){
				this.$toast("当前时间段没有数据");
				return;
			}
			let rows=["设备名称,属性名称,时间,值,单位"];
			this.rawData.forEach(v=>{
				rows.push(this.deviceName+","+this.property_name+","+this.getTime(v.data_time)+","+v.value+","+this.unit);
			});
			// BOM 头保证 Excel 打开中文不乱码
			let csv="﻿"+rows.join("\n");
			let fileName=this.deviceName+"_"+this.property_name+"_近"+this.rangeDays+"天.csv";
			download(csv,fileName,"text/csv");
		},
		handleResize(){
			if(this.chartInstance){
				this.chartInstance.resize();
			}
		},
	}
}
</script>
<style scoped>
.data{
	width: 100%;
	background: #F6F6F6;
	height: 100vh;
	display: inline-block;
	overflow: auto;

	box-sizing: border-box;
}
.data_main{
	width: 100%;
	display: inline-block;
	position: relative;
	height: 100vh;
	padding: 0 30px;
	box-sizing: border-box;
}
.dm_head{
	width: 100%;
	height: 240px;
	background: linear-gradient(180deg, #4E89FF 0%, #4EB8FF 100%);
	border-radius: 20px 20px 20px 20px;
	opacity: 1;
	margin-top: 24px;
	display: inline-block;
}
.dmh_top{
	width: 100%;
	padding: 0 24px;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 24px;
}
.dmht_left{
	font-size: 28px;
	color: #FFFFFF;
	line-height: 40px;
	font-weight: bold;

}
.dmht_right{
	font-size: 24px;
	color: #FFFFFF;
	line-height: 33px;
}
.dmh_bottom{
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 24px;
	box-sizing: border-box;
	margin-top: 50px;
}
.dmhb_left{
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
	font-size: 32px;
	color: #FFFFFF;
	font-weight: bold;
	line-height: 45px;
}
.dmhb_left span:last-child{
	font-size: 24px;
	color: #FFFFFF;
	line-height: 33px;
	margin-top: 16px;
}
.dmhb_right{
	font-size: 64px;
	color: #FFFFFF;
	font-weight: bold;
	line-height: 78px;

}
/* 多属性 Tab */
.prop_tabs{
	width: 100%;
	display: flex;
	overflow-x: auto;
	margin-top: 24px;
	padding-bottom: 4px;
}
.prop_tab{
	flex-shrink: 0;
	padding: 10px 28px;
	margin-right: 16px;
	background: #FFFFFF;
	border-radius: 32px;
	font-size: 26px;
	color: #333333;
}
.prop_tab.active{
	background: #4E89FF;
	color: #FFFFFF;
	font-weight: bold;
}
.dm_data_more{
	width: 100%;
	background: #FFFFFF;
	border-radius: 20px 20px 20px 20px;
	opacity: 1;
	margin-top: 24px;
	display: inline-block;
	padding-bottom: 20px;
}
.ddm_title{
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 24px;
	box-sizing: border-box;
	margin-top: 30px;
	font-size: 32px;
	color: #333333;

}
.ddm_title span:last-child{
	font-size: 24px;
	color: #999999;
	line-height: 33px;

}
/* 时间范围 */
.range_row{
	display: flex;
	padding: 0 24px;
	margin-top: 20px;
}
.range_chip{
	padding: 8px 24px;
	margin-right: 16px;
	background: #F6F6F6;
	border-radius: 28px;
	font-size: 24px;
	color: #666666;
}
.range_chip.active{
	background: #4E89FF;
	color: #FFFFFF;
}
.tu_wrap{
	position: relative;
	width: 100%;
}
.tu_data{
	width: 100%;
	height: 420px;
}
.tu_overlay{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 420px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 26px;
	color: #999999;
	background: rgba(255,255,255,0.8);
}
.chart_actions{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 24px;
	margin-top: 10px;
}
.action_btn{
	padding: 10px 28px;
	background: #F6F6F6;
	border-radius: 32px;
	font-size: 26px;
	color: #4E89FF;
}
.action_tip{
	font-size: 22px;
	color: #999999;
}
/* 历史数据列表 */
.dm_data_table{
	width: 100%;
	background: #FFFFFF;
	border-radius: 20px 20px 20px 20px;
	opacity: 1;
	margin-top: 24px;
	display: inline-block;
	padding-bottom: 24px;
}
.table_tip{
	font-size: 22px;
	color: #999999;
	font-weight: normal;
}
.dt_row{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 54px;
	font-size: 26px;
	color: #333333;
	line-height: 64px;
	border-bottom: 1px dashed #DFDFDF;
	margin: 0 24px;
}
.dt_row:last-child{
	border-bottom: 0;
}
.dt_head{
	font-weight: bold;
	color: #999999;
}
.dt_value{
	font-weight: bold;
}
.dt_empty{
	text-align: center;
	font-size: 26px;
	color: #999999;
	line-height: 80px;
}
.dm_data_warning{
	width: 100%;
	background: #FFFFFF;
	border-radius: 20px 20px 20px 20px;
	opacity: 1;
	margin-top: 24px;
	display: inline-block;
	padding-bottom: 24px;
}
.dmdw_title{
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 32px;
	color: #333333;
	font-weight: bold;
	margin-top: 30px;
	padding: 0 24px;
	box-sizing: border-box;
}
.dmdw_btn{
	width: 152px;
	height: 64px;
	background: #F6F6F6;
	border-radius: 32px 32px 32px 32px;
	opacity: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}
.dmdw_btn .iconfont{
	font-size: 28px;
	color: #4E89FF;
}
.dmdw_btn span{
	font-size: 28px;
	color: #4E89FF;
	margin-left: 8px;
}
.dmdw_list{
	width: 100%;
	display: inline-block;
	padding: 0 24px;
	box-sizing: border-box;

}
.dmdwl_div{
	width: 100%;

	background: #F6F6F6;
	border-radius: 20px 20px 20px 20px;
	padding: 0 30px;
	box-sizing: border-box;
	display: inline-block;
	margin-top: 24px;
}
.dmdwld_head{
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 24px;
}
.dd_left{
	display: flex;
	align-items: center;
	justify-content: flex-start;
}
.ddl_tag{
	width: 120px;
	height: 48px;
	background: #02E4AE;
	border-radius: 8px 8px 8px 8px;
	opacity: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	color: #FFFFFF;
	font-weight: bold;
}
.ddl_name{
	font-size: 28px;
	color: #333333;
	font-weight: bold;
	margin-left: 24px;
	line-height: 40px;
}
.dd_right .iconfont{
	font-size: 32px;
	color: #4E89FF;
}
.dd_right .iconfont:last-child{
	color: #FF5A4E;
	margin-left: 40px;
}
.dmdwld_content{
	width: 100%;
	display: inline-block;
	margin-top: 16px;
	padding: 0 30px;
	box-sizing: border-box;
}
.dmdwldc_div{
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px dashed #DFDFDF;
	font-size: 28px;
	color: #333333;
	line-height: 40px;
	height: 93px;
}
.dmdwldc_div span:last-child{
	font-size: 32px;
	color: #333333;
	font-weight: bold;
	line-height: 45px;
}
.dmdwldc_div:last-child{
	border-bottom: 0px;
}
</style>
